var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#848484",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9784 12.9171L14.9784 23.9171C14.8825 24.0132 14.7687 24.0895 14.6434 24.1415C14.518 24.1936 14.3836 24.2204 14.2479 24.2204C14.1122 24.2204 13.9778 24.1936 13.8524 24.1415C13.7271 24.0895 13.6132 24.0132 13.5174 23.9171L8.70491 19.1046C8.60899 19.0086 8.53289 18.8948 8.48098 18.7694C8.42906 18.6441 8.40234 18.5098 8.40234 18.3741C8.40234 18.2384 8.42906 18.1041 8.48098 17.9788C8.53289 17.8534 8.60899 17.7396 8.70491 17.6436C8.80084 17.5477 8.91472 17.4716 9.04006 17.4197C9.16539 17.3678 9.29972 17.3411 9.43538 17.3411C9.57104 17.3411 9.70538 17.3678 9.83071 17.4197C9.95604 17.4716 10.0699 17.5477 10.1659 17.6436L14.2487 21.7265L24.5191 11.4578C24.7129 11.2641 24.9756 11.1553 25.2496 11.1553C25.5236 11.1553 25.7863 11.2641 25.9801 11.4578C26.1738 11.6516 26.2826 11.9143 26.2826 12.1883C26.2826 12.4623 26.1738 12.725 25.9801 12.9188L25.9784 12.9171Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f9a0c85f667fe81c012fff3741778fb9.svg";
export { ForwardRef as ReactComponent };